module.exports = __webpack_public_path__ + "static/media/wozz_debug_manual.114bc23c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/debug/wozz_debug_manual.jpg
// module id = 289
// module chunks = 0